import { render, staticRenderFns } from "./NewBankAccount.vue?vue&type=template&id=74538f2c&scoped=true&"
import script from "./NewBankAccount.vue?vue&type=script&lang=js&"
export * from "./NewBankAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74538f2c",
  null
  
)

export default component.exports